import { defineComponent } from "vue"
import Utils from '../utils/utils';

export default defineComponent({
    created() {
        if (this.$options?.name == "RouterLink")
            return; //Ignore router fallback

        const pageTitleSuffix = 'Torbay Design Library - Torbay Council Digital Guidelines';
        const pageTitleSep = ' - ';

        const title = Utils.unboxFunction(this.$options?.title, this);
        const desc = Utils.unboxFunction(this.$options?.description, this);

        document.title = [title, pageTitleSuffix].filter(te => te?.length > 0).join(pageTitleSep);
        document.querySelector('meta[name="description"]')?.setAttribute("content", desc ?? title);
    }
});